import { render, staticRenderFns } from "./ProductPoster.vue?vue&type=template&id=7ef06a27&"
import script from "./ProductPoster.vue?vue&type=script&lang=js&"
export * from "./ProductPoster.vue?vue&type=script&lang=js&"
import style0 from "./ProductPoster.vue?vue&type=style&index=0&id=7ef06a27&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports